export enum OS {
  other,
  ios,
  android,
}
